/**
 * Computes the percentage growth between a current and previous value.
 * Returns undefined if the comparison cannot be made (missing values or zero previous).
 */
export function computeGrowth(
    currentValue: number | undefined | null,
    previousValue: number | undefined | null,
): number | undefined {
    if (
        currentValue === undefined || currentValue === null ||
        previousValue === undefined || previousValue === null ||
        previousValue === 0
    ) {
        return undefined;
    }
    return ((currentValue - previousValue) / previousValue) * 100;
}
